import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

/* CDK */
import { DragDropModule } from "@angular/cdk/drag-drop";

/* Angular Material */
import { MatChipsModule } from "@angular/material/chips";
import { MatIconModule } from "@angular/material/icon";

/* Pipes */
import { PipesModule } from "../../pipes/pipes.module";

import { SkillChipListComponent } from "./skill-chip-list.component";

@NgModule({
  declarations: [SkillChipListComponent],
  imports: [
    CommonModule,
    DragDropModule,
    MatChipsModule,
    MatIconModule,
    PipesModule,
  ],
  exports: [SkillChipListComponent],
})
export class SkillChipListModule {}
